import Layout from "../include/layout";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import UsersService from "./UsersService";
import RolesService from "../roles/RolesService";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Filarial from "../include/filarial";

//Creation du schema de validation des entrées
//Utiliser shape pour valider des objets imbriqués avec des structures de validation complexes.
const schema = yup.object().shape({
    nom: yup.string().trim().required("Ce champ est obligatoire !").max(100, "Le maximum de caractères autorisé est dépassé !").min(3, "Vous devez entrer au moins 3 caractères !"),
    username: yup.string().trim().required("Ce champ est obligatoire !").max(20, "Le maximum de caractères autorisé est dépassé !").min(3, "Vous devez entrer au moins 3 caractères !"),
    prenoms: yup.string().required("Ce champ est obligatoire !").max(100, "Le maximum de caractères autorisé est dépassé !").min(3, "Vous devez entrer au moins 3 caractères !"),
    //roles_options: yup.array().required("Ce champ est obligatoire !"),
    telephone: yup.number().positive("Vous devez renseigner une valeur positive").integer().max(999999999999999).min(10000000, "Vous devez entrer au moins 8 chiffres !"),
    email: yup.string().email("Vous devez entrer un email valide !").required("Ce champ est obligatoire !").max(100, "Le maximum de caractères autorisé est dépassé !").min(6, "Vous devez entrer au moins 6 caractères !"),
    password: yup.string()
        .matches(/[A-Z]/, "Le mot de passe doit contenir au moins une lettre majuscule.")
        .matches(/[a-z]/, "Le mot de passe doit contenir au moins une lettre minuscule.")
        .matches(/[0-9]/, "Le mot de passe doit contenir au moins un chiffre.")
        .matches(/[#?!@$%^&*-]/, "Le mot de passe doit contenir au moins un caractère spécial.")
        .required("Ce champ est obligatoire !")
        .max(100, "Le maximum de caractères autorisé est dépassé !")
        .min(6, "Vous devez entrer au moins 6 caractères !"),
    password_confirm: yup.string()
        .oneOf([yup.ref('password'), null], "Les mots de passe ne correspondent pas !")
        .required("Ce champ est obligatoire !"),
});


export default function UserCreate() {
    const activeLink = "UTILISATEURS "

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [nom, setNom] = useState('')
    const [prenoms, setPrenoms] = useState('')
    const [username, setUsername] = useState('')
    const [telephone, setTelephone] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [conf_password, setConfPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)

    const [roles, setRoles] = useState([]); //Liste des roles disponible
    const [selectedRoles, setSelectedRoles] = useState([]);

    const token = useSelector(state => state.auth.token)
    const navigate = useNavigate()
    const animatedComponents = makeAnimated();

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //const for validation form
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        //Fait appel au schema créer précédemment
        resolver: yupResolver(schema)
    })

    ///Save form data
    const handleSubmitUser = async (event) => {
        //event.preventDefault()
        //Recupérer uniquement les id
        var roleIds = selectedRoles.map((option) => option.value)
        //MApping des données
        /*var rolesUser = selectedRoles.map((role) => ({
            idRole: role.value
        }));*/

        let form = {
            nom, prenoms, username, telephone, email, password, roleIds,
        }
        //console.log(form)
        await UsersService.store(form, token).then((response) => {
            //console.log(response.data.data)
            if (response.data.status === 200) {
                //redirection sur index
                navigate(myroutes.users_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 3000
                })
                //setValidationError(response.data.erreur)
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            //setValidationError(error.message)
        });
    }

    const handleRoleSelection = (selectedOptions) => {
        setSelectedRoles(selectedOptions);
    };

    //get liste des roles
    const getRoles = async () => {
        await RolesService.index(token).then((response) => {
            setRoles(response.data.data.roles)
        }).catch(error => {
            console.log(error.message)
        });
    }
    ///Maper les données
    const roleOptions = roles.map((role) => ({
        value: role.id,
        label: role.libelleRole
    }));

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
        getRoles()

    }, [dispatch]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-3">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header">Enregistrement </h5>
                            <div className="card-body">
                                <Form className="needs-validation" noValidate onSubmit={handleSubmit(handleSubmitUser)}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-nom">Nom <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("nom")} id="bs-validation-nom" type="text" value={nom} onChange={(e) => setNom(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.nom?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-prenoms">Prénoms <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("prenoms")} id="bs-validation-prenoms" type="text" value={prenoms} onChange={(e) => setPrenoms(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.prenoms?.message}</div>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephone">Téléphone <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("telephone")} id="bs-validation-telephone" type="number" value={telephone} onChange={(e) => setTelephone(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.telephone?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-email">Email <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("email")} id="bs-validation-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.email?.message}</div>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-roles_options">Rôles <i className="text-danger">*</i></Form.Label>
                                            <Select
                                                options={roleOptions}
                                                isMulti
                                                onChange={handleRoleSelection}
                                                value={selectedRoles}
                                                components={animatedComponents}
                                                required
                                            />
                                            <div className="text-danger">{errors.roles_options?.message}</div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-username">Username <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("username")} id="bs-validation-username" type="text" value={username} onChange={(e) => setUsername(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.username?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-password">
                                                Mot de passe <i className="text-danger">*</i>
                                            </Form.Label>
                                            <div className="input-group">
                                                <Form.Control
                                                    className="form-control"
                                                    {...register("password")}
                                                    id="bs-validation-password"
                                                    type={showPassword ? 'text' : 'password'} // Corrected here
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    placeholder=""
                                                    required={true}
                                                    maxLength={100}
                                                    minLength={8}
                                                />
                                                <span
                                                    className="input-group-text"
                                                    onClick={togglePasswordVisibility}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {showPassword ? '👁️' : '🙈'}
                                                </span>
                                            </div>
                                            <div className="text-danger">{errors.password?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-name">Confirmer Mot de passe <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("password_confirm")} id="bs-validation-password_confirm" type="password" value={conf_password} onChange={(e) => setConfPassword(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.password_confirm?.message}</div>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>


                            </div>
                        </div>
                    </div>
                    {/* /Bootstrap Validation */}
                </div>

            </div>

        </Layout>
    )
}